import React, { useEffect } from 'react';
import AdvisoryFlowLoading from '../../../../flows/src/components/ui/advisory-flow/components/app-shell/AdvisoryFlowLoading';
import useUuid from '../../../../common/src/hooks/useUuid';
import { useParams } from 'react-router';
import useStartFlow from '../../../../flows/src/hooks/useStartFlow';

const DefaultSalesConversation: React.FC = () => {
  const { flowId } = useParams<{ flowId: string }>();
  const uuid = useUuid();
  const startFlow = useStartFlow();

  useEffect(() => {
    startFlow({ flowId, sessionId: uuid });
  }, []);

  return <AdvisoryFlowLoading />;
};

export default DefaultSalesConversation;
